import { Trans } from 'react-i18next';

import {
    Anchor,
    Body1,
    FilledCard,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { DAWModal } from './DAWModal';

type DAWCardFooterProps = {
    toggleGenericModal(): void;
};

export const DAWCardFooter = ({ toggleGenericModal }: DAWCardFooterProps) => {
    const [isDAWModalOpen, { close: closeDAWModal, toggle: toggleDAWModal }] =
        useDisclosure(false);

    return (
        <>
            <FilledCard color="gray" sharp>
                <Trans i18nKey="drx.product.details.daw.unknownSavings">
                    <Body1>
                        {'The healthcare provider indicated "'}
                        <Anchor onClick={toggleDAWModal}>
                            Dispense As Written
                        </Anchor>
                        {
                            '" for the brand. Consult the provider about switching to the '
                        }
                        <Anchor onClick={toggleGenericModal}>generic</Anchor>
                        {' to save.'}
                    </Body1>
                </Trans>
            </FilledCard>

            <DAWModal close={closeDAWModal} isOpen={isDAWModalOpen} />
        </>
    );
};
